import HeartIcon from '@/fo/icons/base/icons/heart.svg';

import { styles } from './UiProductWishlistButton.styles';

export interface UiProductWishlistButtonProps {
  onClick?: () => void;
  className?: string;
  isActive: boolean;
}

export function UiProductWishlistButton({
  onClick,
  className,
  isActive
}: UiProductWishlistButtonProps) {
  const slots = styles({ isActive });

  return (
    <button
      onClick={onClick}
      type="button"
      className={slots.base({ className })}
    >
      <HeartIcon className={slots.icon({ className: 'h-full w-full' })} />
    </button>
  );
}
